import { render, staticRenderFns } from "./wjno.vue?vue&type=template&id=6b58d03b&scoped=true"
import script from "./wjno.vue?vue&type=script&lang=js"
export * from "./wjno.vue?vue&type=script&lang=js"
import style0 from "./wjno.vue?vue&type=style&index=0&id=6b58d03b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b58d03b",
  null
  
)

export default component.exports